const comments = [
  {
    name: '星辰大海',
    time: '2小时前',
    content: '自从发现99视频，追剧再也不用到处找资源了。香蕉视频和红桃视频的内容都能在这找到，而且完全不卡，体验超棒！',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20circular%20portrait%20style%20avatar%20with%20soft%20gradients%2C%20minimal%20geometric%20design%2C%20coral%20and%20peach%20colors%2C%20clean%20simple%20composition%2C%20no%20face%2C%20no%20text&width=100&height=100&seq=avatar-user-01&orientation=squarish',
  },
  {
    name: '追剧达人',
    time: '5小时前',
    content: '91视频的经典老片修复画质真的绝了！在99视频上看了好几部港片经典，重温童年记忆，太感动了。',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20amber%20toned%20circular%20avatar%20design%20with%20flowing%20gradients%2C%20minimal%20geometric%20style%2C%20golden%20and%20coral%20hues%2C%20clean%20composition%2C%20no%20face%2C%20no%20text&width=100&height=100&seq=avatar-user-02&orientation=squarish',
  },
  {
    name: '动漫迷小陈',
    time: '1天前',
    content: '蜜桃视频的动漫更新速度太给力了，每周追的新番都能第一时间在99视频看到，而且画质清晰，强烈推荐！',
    rating: 4,
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20peach%20toned%20circular%20avatar%20design%20with%20soft%20gradients%2C%20minimal%20geometric%20composition%2C%20warm%20coral%20hues%2C%20clean%20simple%20aesthetic%2C%20no%20face%2C%20no%20text&width=100&height=100&seq=avatar-user-03&orientation=squarish',
  },
  {
    name: '周末影迷',
    time: '2天前',
    content: '周末一家人用99视频看了《长安三万里》，孩子看得入迷，画质清晰流畅体验满分。聚合平台太方便了！',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20terracotta%20circular%20avatar%20design%20with%20smooth%20gradients%2C%20minimal%20geometric%20style%2C%20coral%20and%20earth%20tones%2C%20clean%20composition%2C%20no%20face%2C%20no%20text&width=100&height=100&seq=avatar-user-04&orientation=squarish',
  },
  {
    name: '影视发烧友小王',
    time: '3天前',
    content: '作为重度影视爱好者，99视频的资源丰富程度让我惊喜。从最新大片到小众文艺片，红桃视频和91视频的资源互补做得真好。',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20circular%20avatar%20design%20with%20flowing%20amber%20and%20coral%20tones%2C%20minimal%20geometric%20style%2C%20clean%20composition%2C%20no%20face%2C%20no%20text&width=100&height=100&seq=avatar-user-05&orientation=squarish',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            用户好评
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            来自99视频用户的真实反馈，看看大家如何评价这个聚合视频平台的观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {comments.map((comment, idx) => (
            <article
              key={idx}
              className={`bg-background-100 rounded-2xl p-5 border border-background-200/60 ${
                idx === 0 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="font-semibold text-foreground-950 text-sm">{comment.name}</p>
                  <p className="text-xs text-foreground-500">{comment.time}</p>
                </div>
                <div className="ml-auto flex items-center gap-0.5">
                  {Array.from({ length: comment.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent-400 text-xs"></i>
                  ))}
                </div>
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed">
                "{comment.content}"
              </p>
            </article>
          ))}
        </div>

        <div className="text-center mt-8">
          <p className="inline-flex items-center gap-2 text-sm text-foreground-500 bg-background-100 px-5 py-2.5 rounded-full border border-background-200/60">
            <i className="ri-star-fill text-accent-400"></i>
            综合评分 <strong className="text-foreground-950">4.8</strong> / 5.0 · 基于 12,860 条用户评价
          </p>
        </div>
      </div>
    </section>
  );
}